export default __webpack_public_path__ + "static/media/trading-view.86403851.png";